import request from '@/utils/request';
/* 轮播图列表 */
export function bannerList(data) {
  return request({
    url: '/banner/queryBannerPageList',
    method: 'POST',
    data
  });
}
/* 增加轮播图 */
export function bannerAdd(data) {
  return request({
    url: '/banner/saveBanner',
    method: 'POST',
    data
  });
}
/* 修改轮播图 */
export function bannerEdit(data) {
  return request({
    url: '/banner/updateBanner',
    method: 'POST',
    data
  });
}
/* 修改轮播图中的信息展示 */
export function bannerInfo(data) {
  return request({
    url: '/banner/fetchBannerDetailById',
    method: 'POST',
    data
  });
}
/* 删除轮播图 */
export function bannerDel(data) {
  return request({
    url: '/banner/removeBannerById',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/banner.js